import { AuthorizeHttpClientDecorator } from 'infrastructure/decorators/authorize-http-client-decorator';
import { makeCookieStorageAdapter } from 'factory/cache';
import { makeAxiosHttpClient } from 'factory/http';
import { HttpClient } from 'data/protocols/http';

export const makeAuthorizedHttpClient = (): HttpClient =>
  new AuthorizeHttpClientDecorator(makeCookieStorageAdapter(), makeAxiosHttpClient());
